import {
	SET_STATIC_LOOKUPS,
	SET_STATES,
	SET_EMPLOYEE_POSITIONS
} from './global-lookups-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import Vue from 'vue';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'globalLookups',
	namespaced: true,
	state: {
		staticLookups: {},
		states: undefined,
		employeePositions: []
	},
	mutations: {
		[SET_STATIC_LOOKUPS](state, staticLookups) {
			Vue.set(
				state.staticLookups,
				staticLookups.staticLookupTypeId,
				staticLookups
			);
		},
		[SET_STATES](state, states) {
			state.states = states;
		},
		[SET_EMPLOYEE_POSITIONS](state, employeePositions) {
			state.employeePositions = employeePositions;
		}
	},
	actions: {
		async getStaticLookupsAction({ commit }, staticLookupTypesId) {
			const staticLookups = await api.get(
				buildRoute(
					'/globallookups/staticlookups/{staticLookupTypesId}',
					{
						staticLookupTypesId: staticLookupTypesId
					}
				)
			);

			commit(SET_STATIC_LOOKUPS, staticLookups);
		},
		async getStatesAction({ commit }) {
			const states = await api.get('/globallookups/states');

			commit(SET_STATES, states);
		},
		async getEmployeePositionsAction({ commit }, prefix) {
			const positions = await api.get(
				buildRoute('/globallookups/positions', {
					query: {
						prefix: prefix
					}
				})
			);
			commit(SET_EMPLOYEE_POSITIONS, positions);
		}
	},
	getters: {
		staticLookups: state => type => {
			let result;

			if (state.staticLookups && state.staticLookups[type]) {
				result = state.staticLookups[type].items;
			}

			return result;
		},
		states: state => state.states,
		employeePositions: state => state.employeePositions
	}
};
